import Button from "@app/form_components/Button";
import Dropdown from "@app/form_components/Dropdown";
import OldInput from "@app/form_components/OldInput";
import { createUuid, GraphQlWrapper } from "@app/utilities";
import BaseDialog from "./BaseDialog";

export default class CustomSchemaDialog extends BaseDialog {
    /**
     * Editor dialog for editing GraphQL schema
     * @module CustomSchemaDialog
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.addHandle = this.handleAdd.bind(this);
        this.deleteHandle = this.handleDelete.bind(this);
        this.data = {
            name: "Untitled schema",
            value: "",
            schema: "",
            configurationVariable: "",
            type: "URL"
        };
        if (typeof this.props.context.getConfig === "function" && this.props.context.getConfig("name")) {
            this.data.name = this.props.context.getConfig("name");
        }
        if (typeof this.props.context.getConfig === "function" && this.props.context.getConfig("value")) {
            this.data.value = this.props.context.getConfig("value");
        }
        if (typeof this.props.context.getConfig === "function" && this.props.context.getConfig("schema")) {
            this.data.schema = this.props.context.getConfig("schema");
        }
        if (typeof this.props.context.getConfig === "function" && this.props.context.getConfig("type")) {
            this.data.type = this.props.context.getConfig("type");
        }
        if (typeof this.props.context.getConfig === "function" && this.props.context.getConfig("configurationVariable")) {
            this.data.configurationVariable = this.props.context.getConfig("configurationVariable");
        }
        this.error = "";
    }

    /**
     * Add to application
     * @param event
     */
    handleAdd() {
        if (this.props.new) {
            this.props.context.add({
                id: createUuid(),
                name: this.data.name,
                value: this.data.value,
                schema: this.data.schema,
                type: this.data.type, configurationVariable: this.data.configurationVariable,
                createdTime: window.apm.timestamp
            });
        } else {
            this.props.context.setConfig("script", {
                id: this.props.context.getConfig("id"),
                name: this.data.name,
                value: this.data.value,
                schema: this.data.schema,
                type: this.data.type,
                configurationVariable: this.data.configurationVariable,
                createdTime: this.props.context.getConfig("createdTime"),
                lastSavedChange: this.props.context.getConfig("lastSavedChange"),
                lastLocalChange: window.apm.timestamp
            });
        }
        w2popup.close();
    }

    /**
     * Remove from application
     * @param event
     */
    handleDelete() {
        { !this.props.context.props.data.isCommonModule && this.props.context.remove(); }
        w2popup.close();
    }

    /**
     * Set config proxy
     * @param {string} key
     * @param {string} value
     */
    setConfig(key, value) {
        this.data[key] = value;
        if (key === "type" || key === "schema") {
            this.forceUpdate();
        }
    }

    getConfig(key) {
        return this.data[key];
    }
    
    componentDidMount() {
        super.componentDidMount();
        document.addEventListener("ev-dialog-add", this.addHandle);
        document.addEventListener("ev-dialog-delete", this.deleteHandle);
    }

    unregister() {
        document.removeEventListener("ev-dialog-add", this.addHandle);
        document.removeEventListener("ev-dialog-delete", this.deleteHandle);
    }

    testSchemaEndpoint() {
        this.forceUpdate();
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        const addButton = $(".w2ui-popup").find(".add-button");
        const {
            schema,
            value: url
        } = this.data;

        return (
            <div className="container-fluid">
                <div className="script-header" style={{ fontWeight: "normal" }}>
                    <div style={{ width: "78%" }}>
                        <OldInput label={window.l.popup.schema_name}
                            context={this} valKey={"name"} value={this.data.name}
                            disabled={this.props.context.props.isCommonModule} valRules={{ "noEmpty": true }} />
                    </div>
                    <div style={{ width: "20%", marginLeft: "2%" }}>
                        <Dropdown label={window.l.popup.schema_source} optionName={window.l.popup.schema_name}
                            valKey={"type"} selection={this.getConfig("type") === "URL" ? 0 : 1}
                            readyOnly={this.props.context.props.isCommonModule} context={this} options={[{ name: "Endpoint", value: "URL" }, { name: "File", value: "SCHEMA" }]} />
                    </div>
                </div>
                <div style={{ width: "78%" }}>
                    <OldInput label={window.l.popup.schema_definition}
                        disabled={this.props.context.props.isCommonModule} context={this} valKey={"configurationVariable"} value={this.data.configurationVariable}
                    />
                </div>
                <div className="script-wrapper">
                    {(() => {
                        if (this.getConfig("type") === "URL") {
                            return (
                                <div>
                                    <OldInput label={window.l.popup.schema_endpoint}
                                        context={this} valKey={"value"} value={this.data.value}
                                        disabled={this.props.context.props.isCommonModule} valRules={{ "noEmpty": true }} />
                                    <Button context={this}
                                        label={window.l.popup.schema_test} disabled={this.props.context.props.isCommonModule}
                                        callback={() => {
                                            this.testSchemaEndpoint();
                                        }} />
                                </div>
                            );
                        }
                        if (this.getConfig("type") === "SCHEMA") {
                            return (
                                <div style={{ width: "100%" }}>
                                    <table>
                                        <tbody>
                                            <tr>
                                                {(this.getConfig("schema")) ? (
                                                    null
                                                ) : (
                                                    <td style={{ width: "58%", paddingRight: "2%" }}>
                                                        <OldInput label={window.l.popup.test_fetch_at}
                                                            context={this} valKey={"value"} value={this.data.value}
                                                            valRules={{ "noEmpty": true }} disabled={this.props.context.props.isCommonModule} />
                                                    </td>
                                                )}
                                                <td style={{ width: this.getConfig("schema") ? "40%" : "100%" }}>
                                                    <label>{this.getConfig("schema") ? window.l.popup.re_upload : window.l.popup.upload_file}</label>
                                                    <input type="file" name="fileField" style={{ margin: "0" }} disabled={this.props.context.props.isCommonModule}
                                                        onChange={event => {
                                                            const errorD = $(".error-display");
                                                            errorD.html("").hide();
                                                            const file = event.currentTarget.files[0];
                                                            if (!file || (!file.name.endsWith(".graphql") && !file.name.endsWith(".graphqls"))) {
                                                                errorD.html(window.l.popup.error_accessing_file).show();
                                                                return;
                                                            }
                                                            const reader = new FileReader();
                                                            reader.onload = (e) => {
                                                                try {
                                                                    errorD.hide();
                                                                    this.setConfig("schema", e.target.result);
                                                                } catch (err) {
                                                                    // JSON
                                                                    errorD.html(window.l.popup.error_reading_file + err).show();
                                                                }
                                                            };
                                                            reader.readAsText(file);
                                                        }}
                                                    />
                                                    <div className={"error-display"}></div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            );
                        }
                    })()}
                    <div className="graphiql-wrapper">
                        <GraphQlWrapper
                            onSchemaValidate={(isValid) => {
                                addButton.prop('disabled', !isValid);
                            }}
                            schema={(this.getConfig('type') === 'SCHEMA') ? schema : null}
                            url={url}
                        />
                    </div>
                </div>
                <div className="script-footer">
                </div>
            </div>
        );
    }
}